import { DataTableFootnote, DataTableRow } from "./Models";

export const getUsedFootnotes = (
    rows: Array<DataTableRow>,
    footnotes: Array<DataTableFootnote>,
    readOnly: boolean
): Array<DataTableFootnote> => {
    const usedIds: Array<string> = [];

    if (!rows || rows.length === 0 || !footnotes || footnotes.length === 0) return [];

    for (let i = 0; i < rows.length; i++) {
        const row = rows[i];

        if (row.metadata?.visible === false && readOnly) continue;

        for (let j = 0; j < row.cells.length; j++) {
            const cell = row.cells[j];

            if (!cell.footnotes || cell.footnotes.length === 0) continue;
            for (let k = 0; k < cell.footnotes.length; k++) {
                const footnote = cell.footnotes[k];
                if (usedIds.indexOf(footnote) > -1) continue;
                usedIds.push(footnote);
            }
        }
    }

    const usedFootnotes: Array<DataTableFootnote> = [];

    for (let i = 0; i < usedIds.length; i++) {
        const footnote = footnotes.find((x) => x.id === usedIds[i]);
        if (footnote) usedFootnotes.push(footnote);
    }

    return usedFootnotes;
};
